"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getStartFromPosition;
function getStartFromPosition(_ref) {
  var ignoreStreamPosition = _ref.ignoreStreamPosition,
    position = _ref.position,
    playFromPosition = _ref.playFromPosition,
    liveSeekStreamPosition = _ref.liveSeekStreamPosition;
  var startFromPosition = 0;
  if (!ignoreStreamPosition) {
    startFromPosition = position;
  }
  if (playFromPosition) {
    startFromPosition = playFromPosition;
  }
  if (liveSeekStreamPosition) {
    startFromPosition = liveSeekStreamPosition;
  }
  return startFromPosition;
}
//# sourceMappingURL=getStartFromPosition.js.map